module.exports = __webpack_public_path__ + "img/70.2.TN.69951ded.png";